import { internalAxios } from '../../utils/axios/internal';

export const getLandingPageForAuctioneer = async ({ id }) => {
  const response = await internalAxios.get(`/api/wallet/ail/glpfa/${id}`);
  return response.data;
};
